"use strict"; // copyright defined in eosjs/LICENSE.txt

Object.defineProperty(exports, "__esModule", {
  value: true
});